export default function printPrivacyStatementStyles() {
    return `
     #root > * {
        display: none;
    }

    #root > main {
        display: block;
    }

    #root > header > *, #root > main > * , #root > footer > *, svg {
        display: none;
    }

    #root > main > section.privacy-statement-v2 {
        display: block;
    }

    #root > main > section.privacy-statement-v2-mobile {
        display: block;
    }

    #root > main > section.privacy-statement-v2 > * {
        display: none;
    }

    #root > main > section.privacy-statement-v2-mobile > * {
        display: block;
    }

    #root > main > section.privacy-statement-v2-mobile > .privacy-statement-v2__dropdown-wrapper > * {
        display: none;
    } 

    #root > main > section.privacy-statement-v2-mobile > .privacy-statement-v2-mobile__navbar {
        display: none;
    }

    #root > main > section.privacy-statement-v2-mobile > .privacy-statement-v2-mobile__navbar > * {
        display: none;
    }

    #root > main > section.privacy-statement-v2-mobile > .privacy-statement-v2__dropdown__cta-container {
        display: none;
    }

    #root > main > section.privacy-statement-v2-mobile > .privacy-statement-v2__dropdown__cta-container > * {
        display: none;
    }
    
    #root > main > section.privacy-statement-v2 > .privacy-statement-v2__container {
        display: grid;
        grid-template-columns: 100%;
    }

    #root > main > section.privacy-statement-v2 > .privacy-statement-v2__container > * {
        display: none;
    }

    #onetrust-consent-sdk > * {
        display: none;
    }

    #root > main > section.privacy-statement-v2 > .privacy-statement-v2__container > .privacy-statement-v2__content-wrapper {
        display: block;
    }

    .privacy-statement-v2__content-wrapper {
        height: unset !important;
        scrollbar-width: unset !important;
        overflow-y: unset !important;
    }

    .privacy-statement-v2__title {
        font-size: 36px !important;
    }

    .privacy-statement-v2-accordion__detail {
        max-height: unset !important;
        overflow: unset !important;
        padding: 24px;
    }
    `
}